{"schemaVersion":1,"release":{"version":"1.1.1","build":163,"url":"https://cdn.gab.ai/macos/updates/installers/Gab-AI-1.1.1-163.dmg","sha256":"790ed5546218b50692fb9347a1e84c1cc6e37d180f94b65d57a4d431d3633f3e","size":29190776}}
